import { ReactElement, ReactNode } from "react";

import blocks, { BlockType } from "../Blocks";

import { SourceType, SourcesV2 } from "./SourcesField/SelectSource";
import { BlockEnv } from "./env-context";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface BlockProps<TConfiguration = any> {
  type?: BlockType;
  configuration?: TConfiguration;
  name?: string;
  env?: BlockEnv;
  onSave?: (payload: { name: string; configuration: TConfiguration }) => void | Promise<void>;
  onChange?: (payload: {
    name: string;
    configuration: TConfiguration;
    allSources?: Record<string, string[]>;
  }) => void;
  onTypeChange?: (type: BlockType) => void;
  onClose?: () => void;
  sources?: Record<SourceType, string[]>;
  /**
   * Richer `SourcesV2` shape (typed items + optional `sheets` two-layer
   * group) used by Smart-Table blocks that need to navigate
   * cross-sheet / cross-table sources. Non-Smart-Table call sites keep
   * passing the legacy `sources` and remain unchanged.
   */
  sourcesV2?: SourcesV2;
  allSources?: Record<SourceType, string[]>;
  readonly?: boolean;
  showSaveButton?: boolean;
  DefaultFields: (
    props: Omit<BlockProps<TConfiguration>, "DefaultFields">,
  ) => ReactElement[] | ReactElement | ReactNode;
  isDraft?: boolean;
  id?: string | number;
  headerInjection?: ReactNode | ((isScrolled: boolean) => ReactNode);
  banner?: ReactNode;
  forceOpenVariableSelector?: string;
}

export { default as BlockFooter } from "./BlockFooter";
export { default as RetryButton } from "./RetryButton";
export { BlockEnv, isEvalLikeEnv, useBlockEnv, useEnv } from "./env-context";

const Block = <TConfiguration,>({ type, ...rest }: BlockProps<TConfiguration>) => {
  const Core = type ? blocks[type]?.render : undefined;
  if (!Core) {
    return null;
  }

  return (
    <div className="h-full">
      <Core type={type} {...rest} />
    </div>
  );
};

export default Block;
